import { useRef, useState, useEffect, Suspense, ReactNode } from "react";

interface LazyOnVisibleProps {
  children: ReactNode;
  fallback?: ReactNode;
  rootMargin?: string;
}

export function LazyOnVisible({ children, fallback, rootMargin = "200px" }: LazyOnVisibleProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);

  return (
    <div ref={ref}>
      {visible ? (
        <Suspense fallback={fallback || <div className="h-96 animate-pulse bg-muted rounded-xl" />}>
          {children}
        </Suspense>
      ) : (
        fallback || <div className="h-96" />
      )}
    </div>
  );
}
